<span #editor
      class="text"
      spellcheck="false"
      [attr.contenteditable]="editing"
      [textContent]="value.caption"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      data-ideals="chip-text">
  {{value.caption}}
</span>

@if (!editing) {
  <button class="remove-button icons icons-cross"
          aria-label="Close"
          (click)="onRemove()"
          data-ideals="chip-close-button">
  </button>
}
